import AxiosClient from "../../../services/axios.services";

class RecidivismActionsServices {
  getDataRecidivism = (params) =>
    AxiosClient.get(`/api/app/sanciones_reincidencias_casos_disciplinarios/`, {
      headers: { "Content-Type": "application/json" },
      params: params,
    });

    getDataRecidivismActions = (params) => 
      AxiosClient.get(`/api/app/sanciones_reincidencias_medidas_disciplinarios/`, {
        headers: { "Content-Type": "application/json" },
        params: params,
      });
    
    getRecidivismEmployee = (id) =>
      AxiosClient.get(`/api/app/sanciones_reincidencias_casos_disciplinarios_empleado/${id}/`, {
        headers: { "Content-Type": "application/json" },
      });
}


export default new RecidivismActionsServices();